module.exports = __webpack_public_path__ + "img/change-password.26535221.svg";